import * as Types from 'js/components/main/BonusHistory/store/types';
import { actionTypes } from 'js/components/main/BonusHistory/store/constants';

export const updateStatus = (status: string): Types.IUpdateStatusAction => ({
    type: actionTypes.UPDATE_STATUS,
    payload: status
});
